module.exports = __webpack_public_path__ + "img/img_none.a87afce8.png";